import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { PropertyDescriptionModel, PropertyStructureDetailsViewModel } from 'src/common/models';

import { FormattedParagraph } from 'components/common/formatted-paragraph';
import { PropertyDetailsSegment } from './property-details-segment';
import { PropertyStructureDetails } from './property-structure-description';

interface InjectedPropertyDescriptionSectionProps {
  currentHotel: CurrentHotelStore;
  analytics: AnalyticsStore;
}

interface PropertyDescriptionSectionProps {
  propertyDescription: PropertyDescriptionModel;
  propertyStructureDetails?: PropertyStructureDetailsViewModel;
}

export const PropertyDescription: React.FC<PropertyDescriptionSectionProps> = inject('currentHotel', 'analytics')(
  observer(
    ({
      propertyDescription,
      propertyStructureDetails,
      analytics,
      currentHotel: { searchCriteria }
    }: PropertyDescriptionSectionProps & InjectedPropertyDescriptionSectionProps) => {
      if (!propertyDescription) {
        return null;
      }

      const {
        hotelDescription,
        hotelName,
        title,
        taglineDescription,
        propertyAmenitiesDescription,
        recreationAmenityDescription,
        roomAmenitiesDescription,
        spaDescription
      } = propertyDescription;
      const propertyDescriptionAnalytics =
        analytics && analytics.setupTracker ? analytics.setupTracker('.PropertyDescription', 'SeeMore_SeeLess') : undefined;

      const isDateless = searchCriteria && searchCriteria.isDateless;

      return (
        <>
          <PropertyDetailsSegment
            dataStid="section-property-description"
            errorBoundaryLabel="hotel.information.propertyDescription"
            rootClassName="property-description"
            title={title}
            isToggleHidden={false}
            analytics={propertyDescriptionAnalytics}
          >
            <div className="all-t-padding-three">
              <h4 className="uitk-type-heading-500">{hotelName}</h4>
              <div className="all-t-padding-three">
                {isDateless && <FormattedParagraph text={taglineDescription} />}
                <FormattedParagraph text={hotelDescription} />
                {isDateless && <FormattedParagraph text={roomAmenitiesDescription} />}
                {isDateless && <FormattedParagraph text={propertyAmenitiesDescription} />}
                {isDateless && <FormattedParagraph text={recreationAmenityDescription} />}
                {isDateless && <FormattedParagraph text={spaDescription} />}
              </div>
            </div>
          </PropertyDetailsSegment>
          {propertyStructureDetails && <PropertyStructureDetails propertyStructureDetails={propertyStructureDetails} />}
        </>
      );
    }
  )
);

PropertyDescription.displayName = 'PropertyDescriptionSection';
